// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_article":"right_article-3k-Q-3QS","first_item":"first_item-1aowCosD","item":"item-2J1pumAO","check_more":"check_more-24J2Usrc","assess":"assess-3Aelcak3"};